import React, { useEffect } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCIcon, RCCInput, RCCTextArea, RCCTooltip } from "react-common-components";
import { useFieldArray } from "react-hook-form";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import { cardStyle } from "../../styles";
import { IComponentContingencePlans, IContingencePlan } from "./interface";
import ContingencePlanItem from "./item";

const ContingencePlans: React.FC<IComponentContingencePlans> = ({
	control,
	error,
	defaultValue,
	disabled = false,
	register,
	clearErrors
}) => {

	const { translate } = useTranslation();

	const { 
		fields,
		remove,
		append
	} = useFieldArray({
		control,
		shouldUnregister: true,
		name: "ritbb005"
	});

	useEffect(() => {
		append(defaultValue);
	}, []);


	return (
		<RCCGrid
			container
			item
			direction="column"
			alignItems="center"
		>
			<RCCGrid
				container
				item
				xs={12}
				justifyContent="flex-end"
			> 

				{!disabled && (
					<RCCTooltip
						text={translate("Adicionar plano de contigência")}
						color="purple"
						style={{ marginLeft: "0px" }}
					>	
						<RCCButton
							icon={{name: "plus"}}
							color="purple"
							onClick={() => {
								const newField = {} as IContingencePlan;
								newField.id = v4();
								append(newField);
							}}
							size="md"
							layout="isRounded"
						/>
					</RCCTooltip>
				)}


				{!fields || fields.length <= 0 && (
					<>
						<RCCAlert 
							title={translate("Atenção")}
							description={translate("Não foram encontrados resultados para esta pesquisa")}
						/>
					</>
				)}
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				justifyContent="flex-end"
			> 
				{error.ritbb005 && (
					<>
						<RCCIcon name="infoCircle" size={18} color="var(--red)"/>
						<Title color="red" size="xs">{translate("Adicione uma ação ao plano de contingência")}</Title>
					</>
				)}
			</RCCGrid>
					
			{fields && fields.map((field : any, index : number) => (
				<RCCGrid
					container
					item
					key={`_contigencyplansfields${field.rib005Id}${field.id}`}
				>

					<RCCGrid
						container
						item
						styleInline={cardStyle}
					>
						
						<RCCGrid
							item
							container
							justifyContent="flex-start"
							xs={12}
						>
							<Title color="purple" size="md">
								{translate("Plano de contigência")}
							</Title>

						</RCCGrid>
						<RCCGrid 
							item
							container	
							xs={12}			
							direction="column"
							alignItems="center"
							style={{ marginBottom: "20px"}}
						>	

							<RCCGrid
								container
								item
								xs={12}
								md={12}
								justifyContent="center"
								alignItems="center"
							>

								<RCCGrid
									container
									item
									xs={12}
								>

									<RCCGrid
										container
										item
										xs={ disabled ? 12: 11}
										alignItems="center"
										justifyContent="center"
									>
										<RCCInput 
											name={`ritbb005[${index}].rib005Titulo`}
											label={translate("Título")}
											maxLength={100}
											register={register}
											defaultValue={field.rib005Titulo ?? ""}
											error={error.ritbb005 && error.ritbb005[index]?.rib005Titulo}
											disabled={disabled}
											required
										/>	

									</RCCGrid>

									{!disabled && (
										<RCCGrid
											container
											item
											xs={1}
											alignItems="center"
											justifyContent="flex-end"
											style={{ marginTop: "15px" }}
										>

											<RCCTooltip
												color="red"
												text={translate("Remover plano de contigência")}
											>
												<RCCButton
													color="red"
													icon={{
														name: "trash",
														size: 12
													}}
													size="xs"
													layout="isRounded"
													onClick={() => remove(index)}
												/>
											</RCCTooltip>
										</RCCGrid>
									)}

									<RCCTextArea 
										name={`ritbb005[${index}].rib005Descricao`}
										label={translate("Descrição")}
										maxLength={4000}
										register={register}
										defaultValue={field.rib005Descricao ?? ""}
										error={error.ritbb005 && error.ritbb005[index]?.rib005Descricao}
										disabled={disabled}
										required
									/>
								</RCCGrid>	
							</RCCGrid>
						</RCCGrid>	
						<RCCGrid
							item
							container
						>
							<ContingencePlanItem 
								control={control}
								defaultValue={field.ritbb006 ?? null}
								error={error.ritbb005 ? error.ritbb005[index] || {} : {}}
								index={index}
								register={register}
								clearErrors={clearErrors}
								disabled={disabled}
							/>
						</RCCGrid>
						
					</RCCGrid>	
				</RCCGrid>	
			))}			
		</RCCGrid>	
	);
};

export default ContingencePlans;
